import {IconButton} from '@mui/material';
import styled from 'styled-components';
import {tokens} from '../../../theme';
import {type FileFormat} from "../../../theme/tokens/tokens";

export const CardContainer = styled.div<{ $selected: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 12px;
    
    border-radius: ${tokens.radius.md};
    
    background-color: ${({$selected, theme}) => $selected 
            ? theme.palette.action.selectedBackground
            : theme.palette.background.input
    };
    
    border: 2px solid ${({$selected, theme}) => $selected 
            ? theme.palette.dividers.strong 
            : theme.palette.dividers.default
    };
    
    cursor: pointer;
    transition: all 200ms ease;
    position: relative;
    min-width: 0;

    &:hover {
        border-color: ${({theme}) => theme.palette.dividers.strong};
        background-color: ${({theme}) => theme.palette.action.hoveredBackground};
`;

export const CardContent = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
`;

export const FileInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 4px;
    min-width: 0;
`;

export const FileName = styled.div`
    font-size: ${tokens.fontSize.sm};
    font-weight: ${tokens.fontWeight.medium};
    letter-spacing: ${tokens.letterSpacing.base};
    
    color: ${({theme}) => theme.palette.text.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
`;

export const FileMetadata = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: ${tokens.fontSize.xs};
    color: ${({theme}) => theme.palette.text.hint};
`;

export const ExtensionBadge = styled.span<{$format: FileFormat}>`
    display: inline-block;
    padding: 2px 6px;
    border-radius: ${tokens.radius.xs};

    background-color: ${({ $format, theme }) =>
            $format ? theme.palette.fileFormats[$format].bg : theme.palette.background.subtle};

    color: ${({ $format, theme }) =>
            $format ? theme.palette.fileFormats[$format].fg : theme.palette.primary.main};
    
    font-weight: ${tokens.fontWeight.medium};
    text-transform: uppercase;
    font-size: ${tokens.fontSize.xs};
`;

export const DateText = styled.span`
    font-size: ${tokens.fontSize.xs};
`;

export const OptionsButton = styled(IconButton)`
    padding: 4px !important;
    transition: opacity 0.2s;
    margin-left: auto;

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    width: 18px;
`;
